import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=70542400&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70542400')) {
      api.createRecord('70542400', component.options)
    } else {
      api.reload('70542400', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=70542400&", function () {
      api.rerender('70542400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bi1Y7sbPqJZo/JS/comp/ServiceHelp.vue"
export default component.exports